import React, { useState } from 'react';
import caret from '../../assets/icons/caret-language-picker.svg';
import { useSelector } from 'react-redux';

const LanguagePicker = ({ items }) => {
  const [isOpen, setIsOpen] = useState(false);
  const storeState = useSelector((state) => state);
  const currentCountryCode = storeState.cart.currentCountry;

  if (!items || items.length < 1) {
    return;
  }

  const selectedOption = items.find((items) => items.isSelected === true);

  return (
    <>
      <button
        className="language-picker__trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <img
          src={selectedOption.channelFlag}
          className="language-picker__flag"
        />
        <div className="language-picker__current">{currentCountryCode}</div>
        <img
          src={caret}
          className={`language-picker__caret-down${isOpen ? ' rotate' : ''}`}
          alt="Caret"
        />
      </button>
      <ul className={`language-picker__options${isOpen ? ' open' : ''}`}>
        {!!items.length &&
          items.map((item) => (
            <li
              className={`language-picker__option ${
                item.isSelected ? 'current' : ''
              }`}
              onClick={() => (window.location.href = item.url)} // Redirect to the channel's URL
              key={item?.channelSystemId}
            >
              <img src={item?.channelFlag} className="language-picker__flag" />
              {item.channelListName}
            </li>
          ))}
      </ul>
    </>
  );
};

export default LanguagePicker;
